<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
        <g transform="translate(-15 -316)">
            <circle class="a" cx="17" cy="17" r="17" transform="translate(15 316)" 
            :fill="color"/>
            <g transform="translate(-404.23 -32.115)">
                <g transform="translate(429.23 360.431)">
                    <path class="b" d="M438.3,445.137h-8.889a.163.163,0,0,1-.161-.139,2.226,2.226,0,0,1,.662-1.994,3.112,3.112,0,0,1,1.165-.428,2.334,2.334,0,0,0,1.547-.8c0-.006.168-.256-.346-.884a4.144,4.144,0,0,1-.559-3.07,2.191,2.191,0,0,1,4.275,0,4.144,4.144,0,0,1-.559,3.07c-.514.628-.351.878-.349.88a2.336,2.336,0,0,0,1.55.8A3.114,3.114,0,0,1,437.8,443a2.226,2.226,0,0,1,.662,1.994A.163.163,0,0,1,438.3,445.137Zm-8.741-.325h8.593a1.793,1.793,0,0,0-.541-1.542,2.831,2.831,0,0,0-1.047-.375,2.66,2.66,0,0,1-1.736-.919c-.03-.033-.344-.433.354-1.286a3.825,3.825,0,0,0,.49-2.81,1.866,1.866,0,0,0-3.633,0,3.825,3.825,0,0,0,.49,2.81c.7.853.384,1.253.345,1.3a2.653,2.653,0,0,1-1.728.909,2.83,2.83,0,0,0-1.047.375A1.788,1.788,0,0,0,429.562,444.812Z" transform="translate(-429.23 -436.115)" fill="#3c3d3e" stroke="#383935" stroke-width="0.5px"/>
                </g>
                <path class="b" d="M796.588,366a3.111,3.111,0,0,0-1.165-.428,2.336,2.336,0,0,1-1.55-.8s-.165-.252.349-.88a4.145,4.145,0,0,0,.559-3.07,2.191,2.191,0,0,0-4.276,0,4.144,4.144,0,0,0,.559,3.07c.514.628.351.878.346.884a2.335,2.335,0,0,1-1.547.8A3.111,3.111,0,0,0,788.7,366c-.031.022-.061.045-.089.069a1.463,1.463,0,0,0,.25.217l.028-.021a2.831,2.831,0,0,1,1.047-.375,2.653,2.653,0,0,0,1.728-.909c.038-.043.352-.443-.346-1.3a3.825,3.825,0,0,1-.49-2.81,1.866,1.866,0,0,1,3.633,0,3.825,3.825,0,0,1-.49,2.81c-.7.853-.384,1.253-.354,1.286a2.66,2.66,0,0,0,1.736.919,2.832,2.832,0,0,1,1.047.375,1.793,1.793,0,0,1,.541,1.542h-5.212a2.186,2.186,0,0,1,.121.326h5.24a.163.163,0,0,0,.161-.139A2.226,2.226,0,0,0,796.588,366Z" transform="translate(-353.237)" fill="#3c3d3e" stroke="#383935" stroke-width="0.5px"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'UsersIcon',
  props: {
    color: {
      type: String,
      default: 'rgb(165, 216, 103)', // fallback color
    },
  },
}
</script>

<style scoped>
    svg {
        width:34px;
        height: 34px;
    }
</style>